import styled from "styled-components";
import { CheckCircle, TrendingUp, Target, Layers } from "lucide-react";
import { useNavigate } from "react-router-dom";
const ValueSection = styled.section`
  padding: 120px 24px;
  max-width: 1100px;
  margin: auto;
`;

const ValueHeader = styled.div`
  max-width: 760px;
  margin-bottom: 70px;
`;

const ValueTitle = styled.h2`
  font-size: clamp(28px, 4vw, 38px);
  font-weight: 900;
  line-height: 1.2;
  margin-bottom: 18px;
`;

const ValueSub = styled.p`
  font-size: 17px;
  line-height: 1.7;
  color: #9ca3af;
`;

const ValueGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 28px;
`;

const ValueCard = styled.div`
  padding: 28px;
  border-radius: 20px;
  background: rgba(15, 23, 42, 0.62);
  border: 1px solid rgba(148, 163, 184, 0.1);
  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-6px);
    border-color: rgba(56, 189, 248, 0.24);
    box-shadow: 0 24px 70px rgba(56, 189, 248, 0.12);
  }
`;

const IconBox = styled.div`
  width: 46px;
  height: 46px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, #f59e0b, #38bdf8);
  margin-bottom: 16px;
`;

const ValueCardTitle = styled.h3`
  font-size: 18px;
  font-weight: 800;
  margin-bottom: 10px;
`;

const ValueCardText = styled.p`
  font-size: 15px;
  line-height: 1.6;
  color: #9ca3af;
`;

const InlineCTA = styled.button`
  margin-top: 60px;
  padding: 14px 28px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  color: white;
  background: linear-gradient(90deg, #f59e0b, #d97706);
  box-shadow: 0 10px 30px rgba(245, 158, 11, 0.28);
  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-2px) scale(1.02);
    box-shadow: 0 16px 45px rgba(245, 158, 11, 0.36);
  }
`;
export function WhatYouGet() {
  const navigate = useNavigate();
  return (
    <ValueSection>
      <ValueHeader>
        <ValueTitle>What you’ll get after the test</ValueTitle>
        <ValueSub>
          Not generic advice. You’ll get a usable snapshot of where you stand,
          what direction fits best, and what should shape your next roadmap.
        </ValueSub>
      </ValueHeader>

      <ValueGrid>
        <ValueCard>
          <IconBox>
            <Target size={22} />
          </IconBox>
          <ValueCardTitle>Best-fit career direction</ValueCardTitle>
          <ValueCardText>
            Frontend, React Native, Fullstack, backend, or another path based
            on your actual signals, not trends or hype.
          </ValueCardText>
        </ValueCard>

        <ValueCard>
          <IconBox>
            <TrendingUp size={22} />
          </IconBox>
          <ValueCardTitle>Your current level</ValueCardTitle>
          <ValueCardText>
            Beginner, intermediate, or job-ready, with a practical sense of
            what is still missing.
          </ValueCardText>
        </ValueCard>

        <ValueCard>
          <IconBox>
            <Layers size={22} />
          </IconBox>
          <ValueCardTitle>Skill gaps & strengths</ValueCardTitle>
          <ValueCardText>
            What you should double down on, and what is silently slowing your
            growth right now.
          </ValueCardText>
        </ValueCard>

        <ValueCard>
          <IconBox>
            <CheckCircle size={22} />
          </IconBox>
          <ValueCardTitle>Clear next steps</ValueCardTitle>
          <ValueCardText>
            A next-step focus that can turn into a personalized roadmap instead
            of a vague long-term plan.
          </ValueCardText>
        </ValueCard>
      </ValueGrid>

      <InlineCTA onClick={() => navigate("/choose-career-page")}>
        Start Free Career Clarity Test
      </InlineCTA>
    </ValueSection>
  );
}
